import { mapMutations } from 'vuex';

export default {
  methods: {
    ...mapMutations(['setSnackbar']),

    showSnackbar({
      text,
      color,
      buttonText,
      buttonHandler,
    }) {
      this.setSnackbar({
        visible: true,
        text,
        color,
        buttonText,
        buttonHandler,
      });
    },
  },
};
